<template>
  <v-container fluid greybgright>
  <v-toolbar app color="white" id="topbar" class="hidden-sm-and-down" >
   <v-toolbar-title v-if="branddata.brand"><img class="logo" v-bind:src="'https://manage.msa.airportdirecttravel.com/uploads/'+branddata.brand.brand_logo"></v-toolbar-title>
      <v-toolbar-items v-if="bookingreference">
        <v-btn
          flat
          v-for="item in menuItems"
          :key="item.title"
          :to="item.path">
          <v-icon left dark>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </v-toolbar-items>
</v-toolbar>
	  <v-expansion-panel class="hidden-md-and-up" >
    <v-expansion-panel-content expand-icon="menu">
      <div slot="header" v-if="branddata.brand"><img class="logo" v-bind:src="'https://manage.msa.airportdirecttravel.com/uploads/'+branddata.brand.brand_logo"></div>
	  <div slot="header" v-else>
	  Menu
	  </div>
	   <v-btn v-if="bookingreference"
          flat left
		  active-class="mymobcolor"
          v-for="item in menuItems"
          :key="item.title"
          :to="item.path">
          <v-icon left dark>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
	</v-expansion-panel-content>
  </v-expansion-panel>
<v-container grid-list-md >
    <v-layout row wrap>
		<v-flex md9  mt-2 mb-2>
		
        <h2 class="pagetitle">Contact Support</h2>
		<v-layout row wrap>
		<v-flex xs12  mt-2 mb-2 v-if="bookingreference">
	<p class="phone">If you have any queries regarding your booking please call our team on:</p>
	<h2 v-if="branddata.brand">{{this.branddata.brand.brand_pphone}}</h2>
	<p style="margin-top:10px;margin-bottom:2px;"><strong>Our Opening Hours</strong></p>
	<p v-if="branddata.brand" v-html="this.branddata.brand.cs_brandhours"></p> 
		<p v-if="branddata.brand">If you are calling from overseas please call <strong>{{this.branddata.brand.brand_overseas_phone}}</strong>. Outside of these hours, if you are travelling within 72 hours or you have an emergency please call our sales team on <strong>{{this.branddata.brand.brand_ephone}}</strong>. If you are calling from overseas please call <strong>{{this.branddata.brand.Brand_Overseas_Emergency_No}}</strong></p> 

	
	
  	</v-flex>
		</v-layout>
		
		<v-layout row wrap >
		<v-flex xs12  mr-2 pb-5 pl-1 pr-1 white>
		<h3 mb-1>Send us email</h3>
		<v-layout row wrap pt-2 pl-1 >
		<v-flex>
		  <v-alert type="error" dismissible v-model="alert">
			{{ error }}
		  </v-alert>
		</v-flex>
<form @submit.prevent="SubmitSupport">
	
	<v-text-field  v-if="bookingreference" label="Booking Reference" box   v-model="bookingreference" readonly ></v-text-field>
	<v-text-field  v-if="bookingreference==''" label="Booking Reference" box  type="number" v-model="bookingreference_ent" required ></v-text-field>

    <v-select
          :items="items"
          box
          label="Issue Type"
		  name="contact_issue_type"
		  id="contact_issue_type"
		  v-model="contactissuetype"
		  required
		  @change="contact_issue_type_change()"
        ></v-select> 
    <v-textarea v-if="contactissuemessage_show"
          box
          label="Your Message"
		  name="contact_issue_message"
		  id="contact_issue_message"
		  v-model="contactissuemessage"
		  required
        ></v-textarea>
		<v-btn v-if="contactissuemessage_show" type="submit" color="mybuttoncolorsm" :disabled="loading">Email Support</v-btn>
		<div v-if="!contactissuemessage_show">
		<p v-if="this.isAuthenticated && this.branddata.brand.Airport_Contact_Url">For information or questions about your departure airport please visit the airport's website <a :href="this.branddata.brand.Airport_Contact_Url" target="_blank">here</a></p>
		<p v-else>For information or questions about your departure airport please visit the airport's website <a href="https://airportdirecttravel.co.uk/contact-us" target="_blank">here</a></p>
		</div>
  </form>
		</v-layout>
		</v-flex>
		</v-layout>
		
		<v-layout row wrap >
		<v-flex xs12  mt-2 mr-2 pb-5 pt-5 pl-1 pr-1 v-if="isAuthenticated">
		<h3 mb-1>Travel Extras</h3>
<p class="phone" v-if="branddata.brand">Need an airport hotel, resort transfer, tickets for attractions or excurtions or something else? Please call our after sales team on 
{{this.branddata.brand.brand_ephone}} and we will take care of everything.</p> 
	
		</v-flex>
		</v-layout>
		

		
		</v-flex>
		<v-flex md3  mt-2 mb-5 borderleftright v-if="isAuthenticated" pr-3 pl-3 >

		<v-flex xs12  mt-2 mb-5>
		<h3>Confirmation Email</h3>
		<p>Send yourself another copy of your confirmation email. If you do not receive a copy via email, please contact support.</p>
		<v-btn color="mybuttoncolor" @click="ResendConfirmation">Resend Confirmation</v-btn>
		</v-flex>
		
		<v-flex xs12  mt-5 mb-5 greybgright >
		<h3>Passport Details</h3>
		<p>If you are travelling overseas please add your passport details prior to travelling.</p>
		<v-btn  color="mybuttoncolor" to="/passport">Add Details</v-btn>
		</v-flex>		
		
		<v-flex xs12  mt-5 mb-5>
		<h3>Read Our FAQ</h3>
		<p>For help and support with any of your pre-travel queries browse our frequently asked questions.</p>
		<v-btn  v-if="branddata.brand" color="mybuttoncolor"  target="_blank" :href="this.branddata.brand.Brand_FAQ_Link">Read FAQs</v-btn>
		</v-flex>		
		
		<v-flex xs12  mt-5 mb-5 greybgright>
		<h3>Contact Support</h3>
		<p>If you have any queries regarding your booking, please contact our support team.</p>
		<v-btn  color="mybuttoncolor" to="/support">Contact Support</v-btn>
		</v-flex>
		
		
		</v-flex>
		
     
    </v-layout>

    <v-dialog v-model="sumsupport" max-width="290">
      <v-card>
        <v-card-title class="headline">Success</v-card-title>
        <v-card-text>Thank you for submitting your support question.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="sumsupport = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>	    
	
	<v-dialog v-model="confsupport" max-width="290">
      <v-card>
        <v-card-title class="headline">Success</v-card-title>
        <v-card-text>Confirmation Email Resent.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="confsupport = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>	
	<v-footer class="pa-3" color="grey" fixed>
    <v-spacer></v-spacer>
    <div>&copy; {{ new Date().getFullYear() }}</div>
  </v-footer>
  </v-container>
  </v-container>
</template>

<script>
const axios = require('axios');
export default {
    data () {
      return {
        menuItems: [
          { title: 'Dashboard', path: '/dashboard' },
          { title: 'Manage My Booking', path: '/mybooking' },
          { title: 'Add Passport Details', path: '/passport' },
          { title: 'Contact Support', path: '/support' },
          { title: 'Logout', path: '/logout' }
        ],
		items: ['General Support', 'Booking Issue', 'Airport Related Query', 'Other'],
		contactissuetype:'General Support',
		contactissuemessage:'',
		contactissuemessage_show:true,
		alert: false,
		sumsupport: false,
		confsupport: false,
		bookingreference_ent: '',
		branddata: {},
		bookingdata: {},
		
      }
    },
	created () {
		if (this.isAuthenticated) {
		this.buildBooking(JSON.parse(localStorage.getItem("brefcldata")))
		}
	},
	computed: {
      isAuthenticated () {
		//console.log(this.$store.getters.isAuthenticated);
        return this.$store.getters.isAuthenticated
      },
	  
	  bookingreference () {
		  if (this.isAuthenticated) {
			return localStorage.getItem("brefcl")
		  } else {
			return ''
		  }
		},
		
		

		
		error () {
		return this.$store.state.error
	  },
	  loading () {
		return this.$store.state.loading
	  }
	  
    },
	
		watch: {
  error (value) {
    if (value) {
      this.alert = true
    }
  },
  alert (value) {
    if (!value) {
      this.$store.commit('setError', null)
    }
  }
},

methods: {
	buildBooking (data) {
      this.bookingdata = data
    },
	  SubmitSupport (event) {
		if(this.bookingreference)
		{
		this.$store.dispatch('SubmitSupport', { bookingreference: this.bookingreference, contactissuemessage: this.contactissuemessage, contactissuetype: this.contactissuetype });
		}
		else{
		
		this.$store.dispatch('SubmitSupport', { bookingreference: this.bookingreference_ent, contactissuemessage: this.contactissuemessage, contactissuetype: this.contactissuetype });
		}
		this.contactissuemessage='';
		this.sumsupport=false
		this.$swal('Success','Your support request has been submitted.','success')
	  },
	  	  ResendConfirmation()
	  {
		this.$store.dispatch('ResendConfirmation', { bookingreference: this.bookingreference })
		this.confsupport=false
		this.$swal('Success','A copy of your confirmation Email has been successfully sent to <br/><br/><strong>'+this.bookingdata.LeadCustomer.CustomerEmail+'</strong><br/><br/>If you do not receive a copy via email, please check your junk folder just in case. If you are still having trouble please <a href="/support">contact support</a>.','success')
	  },
	  contact_issue_type_change ()
	  {
			this.$nextTick(function () {
			  var sel = this.contactissuetype;
			  if (sel=="Airport Related Query")
			  {
			  this.contactissuemessage_show=false;
			  }
			  else
			  {
			  this.contactissuemessage_show=true;
			  }
			})
	  }
    },
	
	mounted() {
		
		if(localStorage.getItem("brefcldata")===null) 
		{
				var referrer = document.referrer;
				var l = document.createElement("a");
				l.href = referrer;
				var hostname = l.hostname;
				axios.get("https://brands.msa.airportdirecttravel.com/getbrandfromurl?brand_url="+hostname)
				.then(response => {
				this.branddata = JSON.parse(response.request.response); 
				console.log(this.branddata.brand.brand_logo);
				});
   
		}
		else
		{
			if(localStorage.getItem("branddata")===null)
			{
			
			axios.get("https://brands.msa.airportdirecttravel.com/getbrandfromcodeformmb?brand_code="+this.bookingdata.BrandCode)
		.then(response => {
			this.branddata = JSON.parse(response.request.response); 
			localStorage.setItem("branddata",JSON.stringify(this.branddata));
			})
			}
			else{
			this.branddata = JSON.parse(localStorage.getItem("branddata"));
			}
		}
	
	
		}
	
  }
</script>